<template>
  <div class="audio-cards-message">
    <div class="clearboth">
      <div class="rich_audio float-right">
        <div class="audio_single">
          <div class="hdr">
            <div class="img">
              <img :src="context.cards[0].imageUrl" alt="圖片說明">
            </div>
            <div class="info">
              <h2 class="rich-titlle">{{ context.cards[0].title }}</h2>
              <p class="rich-subtitle">{{ context.cards[0].subtitle }}</p>
            </div>
            <div class="player">
              <span v-if="!isPlaying" class="mainbtn paused" @click="playVideo"/>
              <span v-else class="mainbtn playing" @click="pauseVideo"/>
              <i>{{ time | fmtMSS }}</i>
            </div>
          </div>
          <div class="content">
            <div class="rich-btn">
              <button
                v-for="(b,index) of context.cards[0].buttons"
                :key="index"
                @click="openTargetUrl(b.payload, b.actionType)">
              <a v-if="b.actionType == 'text'">{{ b.title }}</a>
              <a v-if="b.actionType == 'url'" :href="b.payload" style="color:#000;text-decoration: none" target="_blank">{{ b.title }}</a>
              <a v-if="b.actionType == 'email'" :href="b.payload" style="color:#000;text-decoration: none" target="_blank">{{ b.title }}</a>
              <a v-if="b.actionType == 'phone'" :href="b.payload" style="color:#000;text-decoration: none">{{ b.title }}</a>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-show="false" class="warpper">
      <video :id="vsName" class="video-js vjs-default-skin my-video" controls preload="auto">
        <source :src="context.cards[0].audioUrl" type="application/x-mpegURL">
      </video>
    </div>
  </div>
</template>

<script>
import videojs from 'video.js'
import 'videojs-contrib-hls'
export default {
  filters: {
    fmtMSS(s) {
      return (s - (s %= 60)) / 60 + (s > 9 ? ':' : ':0') + s
    }
  },
  props: {
    message: {
      type: Object,
      required: true
    },
    vsName: {
      type: String,
      default: '',
      required: false
    }
  },
  data() {
    return {
      time: 0,
      isPlaying: false,
      player: null
    }
  },
  computed: {
    context() {
      
      var contentData = {}
      contentData = JSON.parse(this.message.msgJson)
      for (let i = 0; i < contentData.cards.length; i++) {
        // console.log(contentData.cards[i].text)
        // 處理 超連結 和 email (這裡不需要)
        // this.$set(contentData.cards[i], 'text', this.$handleMessageText(JSON.parse(this.message.msgJson).cards[i].text))
        // 處理按鈕的 email
        for (let j = 0; j < contentData.cards[i].buttons.length; j++) {
          if(contentData.cards[i].buttons[j].actionType === 'email'){
            contentData.cards[i].buttons[j].payload = 'mailto:' +
            contentData.cards[i].buttons[j].payload
          } else if (contentData.cards[i].buttons[j].actionType === 'phone') {
            contentData.cards[i].buttons[j].payload = 'tel:' +
            contentData.cards[i].buttons[j].payload
          }
        }
      }
      // console.log(contentData.cards[0].text)
      // return JSON.parse(this.message.msgJson)
      return contentData;
    }
  },
  beforeDestroy() {
    if (this.player) {
      videojs(this.vsName).dispose() // destory video
    }
  },
  methods: {
    openTargetUrl(payload, actionType) {

      if(actionType == 'text') {
        this.$emit("tag-clicked", payload)
      }
    },
    pauseVideo() {
      this.player.pause()
      this.isPlaying = false
    },
    initVideo() {
      return new Promise((r, j) => {
        const options = {
          hls: {
            withCredentials: false
          }
        }
        this.player = videojs(this.vsName, {
          autoplay: false,
          controls: false,
          sourceOrder: false,
          flash: options,
          html5: options
        })

        this.player.on('ready', () => {
          r()
        })
        this.player.on('error', () => {
          j()
        })
      })
    },
    async playVideo() {
      this.isPlaying = true
      if (!this.player) {
        try {
          await this.initVideo()
          setTimeout(() => {
            this.player.play()
          }, 300)
          this.player.on('timeupdate', event => {
            this.time = Math.floor(this.player.currentTime())
          })
        } catch (error) {
          console.log(error)
        }
      } else {
        this.player.play()
      }
    }
  }
}
</script>

<style scoped>
@import "./styles/audioCardsMessage.css";
</style>



// WEBPACK FOOTER //
// src/components/beautiful-chat/AudioCardsMessage.vue